import React from 'react';
import { Box, Typography } from '@mui/material';
import GridContainer from 'components/shared/GridContainer';
import GridItem from 'components/shared/GridItem';
import Card from 'components/shared/Card';
import VoteResultView from '../../VoteResultView';
import { Motion, VotingResult } from 'store/types/Meeting';

interface MotionViewCardProps {
  motion: Motion;
  votingResult?: VotingResult;
}

const MotionViewCard: React.FunctionComponent<MotionViewCardProps> = ({ motion, votingResult }) => {
  return (
    <Card title={<Typography variant="h6">{motion.title}</Typography>} bordered>
      <GridContainer spacing={1}>
        {motion.fromText && (
          <>
            <GridItem md={2}>
              <Typography>
                <strong>From:</strong>
              </Typography>
            </GridItem>
            <GridItem md={10}>
              <Box sx={{ typography: 'body1' }} dangerouslySetInnerHTML={{ __html: motion.fromText }} />
            </GridItem>
          </>
        )}

        {motion.toText && (
          <>
            <GridItem md={2}>
              <Typography>
                <strong>To:</strong>
              </Typography>
            </GridItem>
            <GridItem md={10}>
              <Box sx={{ typography: 'body1' }} dangerouslySetInnerHTML={{ __html: motion.toText }} />
            </GridItem>
          </>
        )}

        {motion.justification && (
          <>
            <GridItem md={2}>
              <Typography>
                <strong>Justification:</strong>
              </Typography>
            </GridItem>
            <GridItem md={10}>
              <Box sx={{ typography: 'body1' }} dangerouslySetInnerHTML={{ __html: motion.justification }} />
            </GridItem>
          </>
        )}

        <GridItem md={2}>
          <Typography>
            <strong>Motion:</strong>
          </Typography>
        </GridItem>
        <GridItem md={10}>
          <Box sx={{ typography: 'body1' }} dangerouslySetInnerHTML={{ __html: motion.statement }} />
        </GridItem>

        {motion.reason && (
          <>
            <GridItem md={2}>
              <Typography>
                <strong>Reason:</strong>
              </Typography>
            </GridItem>
            <GridItem md={10}>
              <Box sx={{ typography: 'body1' }} dangerouslySetInnerHTML={{ __html: motion.reason }} />
            </GridItem>
          </>
        )}

        {motion.by && (
          <>
            <GridItem md={2}>
              <Typography>
                <strong>By:</strong>
              </Typography>
            </GridItem>
            <GridItem md={10}>
              <Typography>{motion.by}</Typography>
            </GridItem>
          </>
        )}

        {motion.second && (
          <>
            <GridItem md={2}>
              <Typography>
                <strong>Second By:</strong>
              </Typography>
            </GridItem>
            <GridItem md={10}>
              <Typography>{motion.second}</Typography>
            </GridItem>
          </>
        )}

        {motion.discussion && (
          <>
            <GridItem md={2}>
              <Typography>
                <strong>Discussion:</strong>
              </Typography>
            </GridItem>
            <GridItem md={10}>
              <Box sx={{ typography: 'body1' }} dangerouslySetInnerHTML={{ __html: motion.discussion }} />
            </GridItem>
          </>
        )}

        {votingResult && (
          <>
            <GridItem md={2}>
              <Typography>
                <strong>Result:</strong>
              </Typography>
            </GridItem>
            <GridItem md={10}>
              <VoteResultView votingResult={votingResult} />
            </GridItem>
          </>
        )}

        {motion.recommendsTechnicalChange && (
          <>
            <GridItem md={2}>
              <Typography>
                <strong>Is a technical change recommended?:</strong>
              </Typography>
            </GridItem>
            <GridItem md={10}>
              <Typography>{motion.recommendsTechnicalChange}</Typography>
            </GridItem>
          </>
        )}
      </GridContainer>
    </Card>
  );
};

export default MotionViewCard;
